import { breakpoints } from "@brightagency/headstart-common";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { LinkRepeater } from "../../../../constants/types";
import { convertToRelativeUrl } from "../../../../utils";
import { colors } from "../../../../utils/colors";

const Wrapper = styled.ul`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
    margin: 54px 0 26px;
    li {
        display: block;

        a {
            display: block;
            padding: 8px 16px;
            font-size: 14px;
            font-weight: 500;
            text-decoration: none;
            color: ${colors.white};

            &:hover {
                color: ${colors.brandLight};
            }
        }
    }

    ${breakpoints.large} {
        flex-direction: row;
        justify-content: center;
        margin: 60px 0 30px;
    }
`;

export const Links = (props: { links: LinkRepeater, classname: string }) => {
    return (
        <Wrapper className={props.classname}>
            {props.links.map(({ link }, index) => (
                <li key={index}>
                    <Link target={link.target} to={convertToRelativeUrl(link.url)}>
                        {link.title}
                    </Link>
                </li>
            ))}
        </Wrapper>
    );
};
